// src/modules/app-views/toolbox/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'isActive',
    title = 'status',
    dataIndex = 'isActive',
    width = 100,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const isActive = r?.isActive !== false;
      return isActive
        ? <Tag color="success">{translateX('active')}</Tag>
        : <Tag color="default">{translateX('inactive')}</Tag>;
    },
  };
}

export default statusColumn;
